import type { EquipmentDataQueryCache } from '../api';

export const removeShortInventoryFromCache = ({
    previous,
    warehouseId,
    inventoryGuid,
}: {
    previous: EquipmentDataQueryCache | undefined;
    warehouseId: number;
    inventoryGuid: string;
}): EquipmentDataQueryCache | undefined => {
    if (!previous?.data.response.equipment) {
        return previous;
    }

    return {
        ...previous,
        data: {
            ...previous.data,
            response: {
                ...previous.data.response,
                equipment: previous.data.response.equipment.map((warehouse) => {
                    if (warehouse.id !== warehouseId) {
                        return warehouse;
                    }

                    return {
                        ...warehouse,
                        items: warehouse.items.filter((item) => item.guid !== inventoryGuid),
                    };
                }),
            },
        },
    };
};
